// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4d1d7156","455":"d5b31f9e","977":"381f43a5"}[chunkId] + ".chunk.js";
};